export const MAX_WIDTH = 400;
export const XS = 12;
export const SM = 6;
export const MD = 4;
export const ELEVATION_LEVEL = 1;
